/**
 * Online-booking gate shared by the public bar and beauty detail pages.
 *
 * The public detail endpoints return `onlineBookingEnabled` as a strict boolean
 * (an absent flag in the DB comes back as `true`). Bars and beauty are legacy
 * "bookable unless turned off", so only an explicit `false` blocks the CTA.
 * Clubs are the opposite (opt-in, `=== true`), which is why they do not use this.
 * An older API that omits the field keeps today's behavior (not disabled).
 */
export const ONLINE_BOOKING_DISABLED_MESSAGE = "Este local no acepta reservas online por el momento.";

export const isOnlineBookingDisabled = (venue) => venue?.onlineBookingEnabled === false;
